import React from 'react';
import PropTypes from 'prop-types';

import EmailIcon from '@mui/icons-material/Email';
import { Tooltip } from '@mui/material';

import classes from './iconStyles.module.css';

const OnEmailIcon = ({ onEmail, active = true, tooltip = 'Email' }) => {
    return (
        <Tooltip title={tooltip} placement="right-end">
            <div
                className={`${classes.emailIcon} ${!active && classes.disabled}`}
                onClick={active ? onEmail : null}>
                <EmailIcon aria-label="email-icon" role="button" />
            </div>
        </Tooltip>
    );
};

OnEmailIcon.propTypes = {
    onEmail: PropTypes.func,
    active: PropTypes.bool,
    tooltip: PropTypes.string
};

export default OnEmailIcon;
